<mat-spinner diameter="40" strokeWidth="5"></mat-spinner>